<div class="charts-container">
  <div id="left-chart" class="chart-wrapper" [style.height]="'inherit'"></div>
  <div id="right-chart" class="chart-wrapper" [style.height]="'inherit'"></div>
  <h4 *ngIf="!this.chartHeight" class="duration-label">Duration[mm:ss]</h4>
  <app-water-mark></app-water-mark>
</div>
